import { FC, useState } from "react";
import { ResponsiveButton } from "components/Button";
import { Add } from "@mui/icons-material";
import { EntitySelector } from "modals/EntitySelector";
import { getFilteredList } from "utils/Array";
import { CoachPetAvatar } from "components/VetStore/CoachPetAvatar";
import { Box } from "@mui/material";

type SelectMentorProps = {
  coaches: any[];
  selectedMentors: any[];
  onSelect: (mentor: any) => void;
};

export const SelectMentor: FC<SelectMentorProps> = ({
  coaches,
  selectedMentors,
  onSelect,
}) => {
  const [open, setOpen] = useState(false);
  if (!coaches) return null;

  return (
    <>
      <ResponsiveButton
        onClick={() => setOpen(true)}
        icon={<Add />}
        variant="contained"
      >
        Select Mentor
      </ResponsiveButton>
      <EntitySelector
        open={open}
        onClose={() => setOpen(false)}
        title="Select a mentor"
        listEntities={getFilteredList(coaches, selectedMentors, "user_id")}
        filterCriteria={(text, data) =>
          data.name.toLowerCase().includes((text || "").toLowerCase())
        }
        keyField="user_id"
        displayField="name"
        displayImageField="picture_url"
        renderItemPrefix={(data: any) => (
          <Box sx={{ mr: 1 }}>
            <CoachPetAvatar
              pictureUrl={data.picture_url}
              name={data.name}
              equippedStoreItems={data.equipped_store_items}
              avatarSize={36}
            />
          </Box>
        )}
        onSelect={onSelect}
      />
    </>
  );
};
